module.exports = __webpack_public_path__ + "assets/img/kv-1f823e0f.jpg";